import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    stickerPackages: [],
    stickerPackagesVisible: false
  },
  getters: {},
  actions: {
    setStickerPackages: function (context, stickerPackages) {
      context.commit("set_StickerPackages", stickerPackages);
    },
    showStickerPackages: function (context, stickerPackagesVisible) {
      context.commit("show_StickerPackages", stickerPackagesVisible);
    },
  },
  mutations: {
    set_StickerPackages: function (state, stickerPackages) {
      state.stickerPackages = stickerPackages;
    },
    show_StickerPackages: function (state, stickerPackagesVisible) {
      state.stickerPackagesVisible = stickerPackagesVisible;
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_sticker.js